module.exports = __webpack_public_path__ + "static/img/blbd-img3.700ddc49.png";